import { createApp } from 'vue';
import App from './App.vue';
// Don't import router here yet
import './assets/styles.scss';
import Aura from '@primeuix/themes/aura';
import PrimeVue from 'primevue/config';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createPinia } from 'pinia';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import 'leaflet/dist/leaflet.css'

const app = createApp(App);

// Set up Pinia FIRST
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

// NOW import and use router (after Pinia is ready)
import router from './router';
app.use(router);

app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.app-dark'
        }
    }
});

app.use(ToastService);
app.use(ConfirmationService);

app.mount('#app');
